import React, { useState } from 'react';
import Tab from '../../components/Tab';
import Tabs from '../../components/Tabs';
import WriteItem from '../Writes/components/WriteItem';
import { Users } from 'react-feather';
import { useQuery } from '@apollo/react-hooks';
import { GET_TEACHER_BOOKS } from './services/graphql';
import { BOOK_STATUS } from '../../services/utils/constants';
import { PlusCircle, ChevronDown, ChevronUp, Search } from 'react-feather';
import { Link } from '@reach/router';
import styles from '../Writes/Writes.module.scss';

const NEW_TO_OLD = 'Date New To Old';
const OLD_TO_NEW = 'Date Old To New';

const NewDashboard = () => {
    const { data, loading, error } = useQuery(GET_TEACHER_BOOKS, {
        fetchPolicy: 'network-only',
    });

    const [searchTermCompletedWrites, setSearchTermCompletedWrites] =
        useState('');
    const [searchThermCurrentWrites, setSearchThermCurrentWrites] =
        useState('');
    const [searchThermArchivedWrites, setSearchThermArchivedWrites] =
        useState('');

    const [sortOrder, setSortOrder] = useState(NEW_TO_OLD);
    const [currentView, setCurrentView] = useState('currentWrites');

    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error.message}</p>;

    if (data?.currentTeacher) {
        const classBooks = data?.currentTeacher?.classBooks || [];

        const completedBooks = classBooks.filter(
            (b) => b?.status >= BOOK_STATUS.completed && !b.archived
        );
        const archivedBooks = classBooks.filter((book) => book.archived);
        const currentWrites = classBooks.filter(
            (book) => book.status < BOOK_STATUS.completed && !book.archived
        );

        const visibleBooks =
            searchTermCompletedWrites === ''
                ? completedBooks
                : completedBooks.filter((b) =>
                      b.bookTemplate?.name
                          ?.toLowerCase()
                          .includes(searchTermCompletedWrites)
                  );
        const visibleBooksCurrentWrites =
            searchThermCurrentWrites === ''
                ? currentWrites
                : currentWrites.filter((b) =>
                      b.bookTemplate?.name
                          ?.toLowerCase()
                          .includes(searchThermCurrentWrites)
                  );
        const sortedBooks =
            sortOrder === NEW_TO_OLD
                ? [...visibleBooks].sort((a, b) =>
                      b.completedAt.localeCompare(a.completedAt)
                  )
                : [...visibleBooks].sort((a, b) =>
                      a.completedAt.localeCompare(b.completedAt)
                  );

        const visibleBooksArchived =
            searchThermArchivedWrites === ''
                ? archivedBooks
                : archivedBooks.filter((b) =>
                      b.bookTemplate?.name
                          ?.toLowerCase()
                          .includes(searchThermArchivedWrites)
                  );

        return (
            <>
                <div className='page-header'>
                    <div className='page-header__content'>
                        <div className='page-header__content__inner'>
                            <h2 className='page-header__content__title'>
                                <Users /> Select a write{' '}
                            </h2>
                        </div>
                    </div>
                </div>
                <div className='card card-mobile u-m-base-2'>
                    <Tabs>
                        <Tab
                            selected={currentView === 'currentWrites'}
                            onClick={() => setCurrentView('currentWrites')}
                        >
                            Current writes
                        </Tab>
                        <Tab
                            selected={currentView === 'completedWrites'}
                            onClick={() => setCurrentView('completedWrites')}
                        >
                            Completed writes
                        </Tab>
                        <Tab
                            selected={currentView === 'archivedWrites'}
                            onClick={() => setCurrentView('archivedWrites')}
                        >
                            Archived
                        </Tab>
                    </Tabs>
                </div>

                <div className={styles.writesWrapper}>
                    {currentView === 'currentWrites' && (
                        <>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <div className={styles.utilitiesSearch}>
                                        <input
                                            className={`${styles.utilitiesBtn} basic-form__text-box u-align-center`}
                                            type='search'
                                            placeholder='Search'
                                            onChange={(e) =>
                                                setSearchThermCurrentWrites(
                                                    e.target.value
                                                )
                                            }
                                            value={searchThermCurrentWrites}
                                        />
                                        {!searchThermCurrentWrites && (
                                            <Search
                                                size={20}
                                                className={
                                                    styles.utilitiesSearchIcon
                                                }
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                             <div className='row'>
                                {searchThermCurrentWrites !== '' &&
                                    visibleBooksCurrentWrites.length === 0 &&
                                    'No writes match your search criteria'}
                            </div>
                            <div className='row'>
                                <div className='col-lg-8 col-md-8'>
                                    <div className='row'>
                                    <Link
                                        to='/startWrite'
                                        className={`${styles.addTaskBtn} col-lg-4 col-md-6`}
                                    >
                                        <div className='card card-hover'>
                                            <div
                                                className={styles.addTaskBtnContent}
                                            >
                                                <PlusCircle
                                                    className={
                                                        styles.addTaskBtnIcon
                                                    }
                                                />
                                                New Writing
                                            </div>
                                        </div>
                                    </Link>
                                    {visibleBooksCurrentWrites.map((book) => {
                                        if (book.status >= BOOK_STATUS.completed) {
                                            return null;
                                        }
                                        return (

                                                <WriteItem key={book.id} book={book}/>

                                        );
                                    })}
                                    </div>
                                </div>
                                <div className={`col-lg-3 col-md-3 ${styles.welcomeCard}`}>
                                    <h2>
                                        Welcome to BoomWriter !
                                    </h2>
                                    <p>
                                        BoomWriter is our collaborative writing platform where students can read, 
                                        write, and vote their way to creating their very own book. 
                                        Choose from a wide range of story starters, each designed for different age groups, 
                                        and watch the adventure unfold as students take the story in new directions.
                                        <br></br>
                                        To begin, simply click the + and start your writing journey!
                                    </p>
                                    <h2>
                                        Take a tour
                                    </h2>
                                     <div className={styles.videoWrapper}>
                                        <iframe
                                            src="https://www.youtube.com/embed/C9Apgxsel4Q"
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                        </div>
                                     <a 
                                        className={`btn btn-primary ${styles.writingBtn}`} 
                                        href="https://www.boomwriter.co.uk/writingframework"
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                    >
                                        Writing Framework
                                    </a>
                                    <a 
                                        className={`btn btn-primary ${styles.writingBtn} ${styles.helpBtn}`} 
                                        href="https://www.boomwriter.co.uk/helpandresources"
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                    >
                                        Help and Resources
                                    </a>
                                </div>
                            </div>

                           
                        </>
                    )}

                    {currentView === 'completedWrites' && (
                        <>
                            <div className='row u-m-base-2'>
                                <div className='col-md-4'>
                                    <div className={styles.utilitiesSearch}>
                                        <input
                                            className={`${styles.utilitiesBtn} basic-form__text-box u-align-center`}
                                            type='search'
                                            placeholder='Search Activities'
                                            onChange={(e) =>
                                                setSearchTermCompletedWrites(
                                                    e.target.value
                                                )
                                            }
                                            value={searchTermCompletedWrites}
                                        />
                                        {!searchTermCompletedWrites && (
                                            <Search
                                                size={20}
                                                className={
                                                    styles.utilitiesSearchIcon
                                                }
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <button
                                        className={`${styles.utilitiesBtn} basic-form__text-box u-align-center`}
                                        onClick={() =>
                                            setSortOrder(
                                                sortOrder === NEW_TO_OLD
                                                    ? OLD_TO_NEW
                                                    : NEW_TO_OLD
                                            )
                                        }
                                    >
                                        <span className='u-m-right-1'>
                                            {sortOrder}
                                        </span>
                                        {sortOrder === NEW_TO_OLD ? (
                                            <ChevronDown color='#bbb' />
                                        ) : (
                                            <ChevronUp color='#bbb' />
                                        )}
                                    </button>
                                </div>
                            </div>
                            <div className='row'>
                                {sortedBooks.length === 0 ? (
                                    <>
                                        {searchTermCompletedWrites !== ''
                                            ? 'No writes match your search criteria'
                                            : 'No completed writes'}
                                    </>
                                ) : (
                                    sortedBooks.map((book) => (
                                        <WriteItem key={book.id} book={book} />
                                    ))
                                )}
                            </div>
                        </>
                    )}

                    {currentView === 'archivedWrites' && (
                        <>
                            <div className='row u-m-base-2'>
                                <div className='col-md-4'>
                                    <div className={styles.utilitiesSearch}>
                                        <input
                                            className={`${styles.utilitiesBtn} basic-form__text-box u-align-center`}
                                            type='search'
                                            placeholder='Search Activities'
                                            onChange={(e) =>
                                                setSearchThermArchivedWrites(
                                                    e.target.value
                                                )
                                            }
                                            value={searchThermArchivedWrites}
                                        />
                                        {!searchThermArchivedWrites && (
                                            <Search
                                                size={20}
                                                className={
                                                    styles.utilitiesSearchIcon
                                                }
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                {visibleBooksArchived.length === 0 ? (
                                    <>
                                        {searchThermArchivedWrites !== ''
                                            ? 'No writes match your search criteria'
                                            : 'No archived writes'}
                                    </>
                                ) : (
                                    visibleBooksArchived.map((book) => (
                                        <WriteItem key={book.id} book={book} />
                                    ))
                                )}
                            </div>
                        </>
                    )}

                    {currentView === 'currentWrites' && (
                        <div className={styles.writesFooter}>
                            <Link to='/startWrite' className='btn btn-primary'>
                                + Create new
                            </Link>
                        </div>
                    )}
                </div>
            </>
        );
    }
    return null;
};

export default NewDashboard;
